<template>
    <main class="main-content main-content-specials">
        <div class="container-fluid container-specials">
            <div class="row">
                <div class="col-12">
                    <p class="specials-title"><strong>Especiais</strong></p>
                </div>
            </div>
        </div>

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container container-noticies-block" v-if="especiais">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="row" v-for="especial in especiais" :key="especial.id">
                        <div class="col-12">
                            <router-link 
                                class="noticies-item noticies-item--nofloat noticies-item--img-small"
                                :to="especial.url">
                                <div class="noticies-item--image" v-if="especial.image">
                                    <img :src="utils.image(especial.image, width=160, height=104)" alt="" />
                                </div>
                                <div class="noticies-item--info">
                                    <p class="noticies__label">
                                        <strong>{{utils.date(especial.meta.first_published_at)}}</strong>
                                    </p>
                                    <p class="noticies__title noticies__title--white"><strong>{{especial.title}}</strong></p>
                                    <p class="noticies__text">{{especial.subtitle}}</p>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    

                    <div class="row">
                        <div class="col-12">
                            <Pagination :count="count" :limit="limit" />
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div id='div-gpt-ad-1603502104885-0'></div>
                </div>
            </div>
        </div>
        
    </main>
</template>

<script>
import page from '@/api/page'
import utils from '@/utils'

import Pagination from '@/components/Pagination'

export default {
    name: "Index",
    components: {Pagination},
    head:{
        title: {
            inner: 'Especiais'
        }
    },
    data(){
        return {
            utils:utils,
            especiais: null,
            destaques: null,
            principal: null,
            medio1: null,
            medio2: null,
            count: 0,
            limit: 17,
        }
    },
    computed: {
        current_page: function() {
            if ('page' in this.$route.query) {
                return this.$route.query.page
            }
            return 1
        }
    },
    watch: {
        current_page: function() {
            this.getEspeciais()
        }
    },
    methods:{
        async getEspeciais() {
            this.especiais = null
            this.destaques = null
            this.principal = null
            this.medio1 = null
            this.medio2 = null
            const response = await page.list(
                'specials.SpecialPage', 
                'image,url', 
                this.current_page,
                this.limit,
            )
            if (response.ok) {
                this.especiais = response.data.items
                this.count = response.data.meta.total_count
            }
        },
    },
    mounted() {
        this.getEspeciais()

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.defineSlot('/1513505/v1_gweb_arroba_lateral', [300, 250], 'div-gpt-ad-1603502104885-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices();
            googletag.display('div-gpt-ad-1603501550614-0');
            googletag.display('div-gpt-ad-1603502104885-0');
        })
    }
}
</script>